import type { ReactNode } from 'react';
import { Suspense } from 'react';

import Box from '@mui/material/Box';
import { useLocation } from 'react-router';

import Loader from '@/shared/ui/feedback/Spinner';

const defaultFallback = (
  <Box sx={{ height: '100dvh' }}>
    <Loader />
  </Box>
);

const SuspenseWrapper = ({
  children,
  customKey,
  fallback
}: {
  children: ReactNode;
  customKey?: string;
  fallback?: ReactNode;
}) => {
  const { pathname } = useLocation();

  return (
    <Suspense
      key={customKey ?? pathname}
      fallback={fallback ?? defaultFallback}
    >
      {children}
    </Suspense>
  );
};

export const withSuspense = (element: ReactNode, customKey?: string, fallback?: ReactNode) => (
  <SuspenseWrapper
    customKey={customKey}
    fallback={fallback}
  >
    {element}
  </SuspenseWrapper>
);
